module.exports = __webpack_public_path__ + "static/media/taipingshan1.cdfabc27.webp";